var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DataCache } from '../../DataCache';
import { SavedOrder } from './SavedOrder';
export function Serialize(savedOrder) {
    var _a, _b, _c;
    const serializedData = {
        Id: savedOrder.Id,
        OpenedId: savedOrder.OpenedId,
        Status: savedOrder.Status,
        StatusError: savedOrder.StatusError,
        AccountId: (_a = savedOrder.Account) === null || _a === void 0 ? void 0 : _a.userPin,
        AccountName: savedOrder.AccountName,
        InstrumentTradableId: (_b = savedOrder.Instrument) === null || _b === void 0 ? void 0 : _b.InstrumentTradableID,
        InstrumentRouteId: (_c = savedOrder.Instrument) === null || _c === void 0 ? void 0 : _c.Route,
        InstrumentName: savedOrder.InstrumentName,
        Active: savedOrder.Active,
        Operation: savedOrder.Operation,
        ProductType: savedOrder.ProductType,
        Cash: savedOrder.Cash,
        QuantityLots: savedOrder.QuantityLots,
        DisclosedQuantityLots: savedOrder.DisclosedQuantityLots,
        OrderType: savedOrder.OrderType,
        TIF: savedOrder.TIF,
        TIFExpiration: savedOrder.TIFExpiration,
        StopPrice: savedOrder.StopPrice,
        Price: savedOrder.Price,
        SLTPHolder: savedOrder.SLTPHolder,
        LinkedPriceType: savedOrder.LinkedPriceType,
        LinkedPriceOffset: savedOrder.LinkedPriceOffset,
        Leverage: savedOrder.Leverage,
        UserComment: savedOrder.UserComment,
        IsAllowOTHTrading: savedOrder.IsAllowOTHTrading
    };
    return JSON.stringify(serializedData, (key, value) => {
        if (Number.isNaN(value)) {
            return 'NaN';
        }
        else {
            return value;
        }
    });
}
export function DeserializeAsync(savedOrderString) {
    return __awaiter(this, void 0, void 0, function* () {
        const serializedData = JSON.parse(savedOrderString);
        const account = DataCache.GetAccountById(serializedData.AccountId);
        const savedOrder = new SavedOrder(serializedData.Id);
        savedOrder.OpenedId = serializedData.OpenedId;
        savedOrder.Status = Number(serializedData.Status);
        savedOrder.StatusError = serializedData.StatusError;
        savedOrder.Account = account;
        savedOrder.AccountName = serializedData.AccountName;
        savedOrder.Instrument = yield DataCache.getInstrumentByInstrumentTradableID_NFL(serializedData.InstrumentTradableId, serializedData.InstrumentRouteId);
        savedOrder.InstrumentName = serializedData.InstrumentName;
        savedOrder.Active = Boolean(serializedData.Active);
        savedOrder.Operation = Number(serializedData.Operation);
        savedOrder.ProductType = Number(serializedData.ProductType);
        savedOrder.Cash = Number(serializedData.Cash);
        savedOrder.QuantityLots = Number(serializedData.QuantityLots);
        savedOrder.DisclosedQuantityLots = Number(serializedData.DisclosedQuantityLots);
        savedOrder.OrderType = Number(serializedData.OrderType);
        savedOrder.TIF = Number(serializedData.TIF);
        savedOrder.TIFExpiration = new Date(serializedData.TIFExpiration);
        savedOrder.StopPrice = isNullOrUndefined(serializedData.StopPrice) ? NaN : Number(serializedData.StopPrice);
        savedOrder.Price = isNullOrUndefined(serializedData.Price) ? NaN : Number(serializedData.Price);
        savedOrder.SLTPHolder.copyFrom(serializedData.SLTPHolder);
        savedOrder.LinkedPriceType = Number(serializedData.LinkedPriceType);
        savedOrder.LinkedPriceOffset = Number(serializedData.LinkedPriceOffset);
        savedOrder.Leverage = isNullOrUndefined(serializedData.Leverage) ? null : Number(serializedData.Leverage);
        savedOrder.UserComment = serializedData.UserComment;
        savedOrder.IsAllowOTHTrading = isNullOrUndefined(serializedData.IsAllowOTHTrading)
            ? null
            : Boolean(serializedData.IsAllowOTHTrading);
        return savedOrder;
    });
}
